import { preloadPincodeData } from './formService';
import { journeyActions } from '../store/journeySlice';
import { PINCODE_MASTER_CACHE_KEY } from '../common/utils/pincodeMasterUtils';

/**
 * Loads the full pincode master once and stores it in Redux for state/city dropdowns
 * and bidirectional pin ↔ location sync across lead and proposal.
 */
export const fetchPincodeMasterCached = () => async (dispatch, getState) => {
  const existing = getState().journey.apiCache?.[PINCODE_MASTER_CACHE_KEY];
  if (Array.isArray(existing?.data) && existing.data.length > 0) {
    return existing.data;
  }

  const items = await preloadPincodeData();
  dispatch(
    journeyActions.setApiCache({
      key: PINCODE_MASTER_CACHE_KEY,
      data: items,
    }),
  );
  return items;
};
